import posthog, { Properties } from 'posthog-js/dist/module.slim';

import { ABTestingService } from '@pflegia/ui/application/interfaces/ab-testing-service.interface';

export class PostHogService implements ABTestingService {
  getID() {
    return posthog.get_distinct_id();
  }
  identify(id?: string, ...args: unknown[]) {
    posthog.identify(id ?? this.getID(), ...(args as Properties[]));
  }
  reset(resetDeviceId?: boolean) {
    posthog.reset(resetDeviceId);
  }
}
